export function IsHTTPMethod(value) {
    return ['GET', 'HEAD', 'POST', 'PUT', 'DELETE', 'OPTIONS'].includes(value);
}
//# sourceMappingURL=functions.js.map